import React from 'react'
import BillingSettingsModule from "../../components-user/manage-company/Billing";

export default function BillingSettings() {
  return (
    <BillingSettingsModule />
  )
}
